const mobileMenuSubMenuButtons = document.querySelectorAll( '.mobile-header-main-menu button' )
const mobileMenuButton = document.getElementById( 'mobileMenuButton' )
const mobileMenus = document.getElementById( 'mobileMenus' )
const mobileHeaderBar = document.getElementById( 'mobileHeaderBar' )
const mobileMenuFocusContainer = document.getElementById( 'mobileMenuFocusContainer' )
let   mobileMenuIsTransitioning = false
let   transitionDuration = 750

const closeMenu = function() {

    mobileMenuButton.setAttribute( 'aria-expanded', false )
    // mobileMenus.style.opacity = '0'
    mobileMenus.style.right   = '-100%'

    setTimeout( () => {
        mobileHeaderBar.classList.remove( 'has-visible-menu' )
    }, transitionDuration / 4 )

    setTimeout( () => {
        mobileMenus.style.display = 'none'
        mobileMenuIsTransitioning = false
        mobileMenus.removeAttribute('style')
    }, transitionDuration )

}


const openMenu = function() {

    mobileMenuButton.setAttribute( 'aria-expanded', true )
    mobileMenus.style.display = 'block'
    mobileHeaderBar.classList.add( 'has-visible-menu' )

    // Slight delay to allow for 'block' display first
    setTimeout( () => {
        mobileMenus.style.right = '0'
        mobileMenuIsTransitioning = false
    }, 5 )

}


const getNextExpandStatus = function() {

    const expanded = mobileMenuButton.getAttribute( 'aria-expanded' ) === 'true' ? false : true

    return expanded

}


const init = function() {

    // Deal with the main menu
    if ( mobileMenuButton ) {

        // Listen for clicks on the menu display toggle button
        // and toggle the menu display
        mobileMenuButton.addEventListener( 'click', () => {
            
            if ( mobileMenuIsTransitioning ) return

            mobileMenuIsTransitioning = true

            const nextExpand = getNextExpandStatus()

            if ( nextExpand ) {
                openMenu()
            } else {
                closeMenu()
            }

        } )

        // Listen for "Escape" key press and close the menu
        document.onkeydown = function( event ) {

            if ( event.key === 'Escape' ) {
    
                if ( mobileMenuIsTransitioning ) return

                const nextExpand = getNextExpandStatus()
    
                // Close menu
                if ( !nextExpand ) {
                    mobileMenuIsTransitioning = true
                    closeMenu()
                    mobileMenuButton.focus()
                }
    
            }
    
        };

        // Listen for focus to leave the menu focus container
        // and close the menu if the focus leaves
        mobileMenuFocusContainer.addEventListener( 'focusout', ( event ) => {

            if ( mobileMenuFocusContainer.contains( event.relatedTarget ) ) return

            closeMenu()

        });

    }

    // Deal with submenus within the main menu
    if ( mobileMenuSubMenuButtons ) {

        mobileMenuSubMenuButtons.forEach( button => {

            let transitioning = false
            const subMenu = button.nextElementSibling

            // Listen for clicks on submenu toggle buttons
            // and toggle accordingly
            button.addEventListener( 'click', () => {

                if ( transitioning ) return

                transitioning = true

                if ( subMenu.hasAttribute( 'style' ) ) {

                    subMenu.style.height = subMenu.scrollHeight + 'px'

                    setTimeout( () => {
                        button.setAttribute( 'aria-expanded', 'false' )
                        subMenu.style.height = '0px'
                    }, 5 )
                                        
                    setTimeout( () => {
                        subMenu.removeAttribute( 'style' )
                        transitioning = false
                    }, 245 )

                } else {

                    button.setAttribute( 'aria-expanded', 'true' )
                    subMenu.style.display = 'block'

                    setTimeout( () => {
                        subMenu.style.height = subMenu.scrollHeight + 'px'
                    }, 5 )
                    setTimeout( () => {
                        subMenu.style.height = 'auto'
                        transitioning = false
                    }, 245 )

                }

            } )


        } )

    }

}


const api = {
    init: init
}


export default api;
